import { useState, useCallback } from 'react'

/**
 * Custom hook to replace Chakra UI's useDisclosure
 * Provides open/close state management for modals, drawers, etc.
 */
export function useDisclosure(defaultIsOpen = false) {
    const [isOpen, setIsOpen] = useState(defaultIsOpen)

    const onOpen = useCallback(() => {
        setIsOpen(true)
    }, [])

    const onClose = useCallback(() => {
        setIsOpen(false)
    }, [])

    const onToggle = useCallback(() => {
        setIsOpen((prev) => !prev)
    }, [])

    return {
        isOpen,
        onOpen,
        onClose,
        onToggle,
    }
}

